export const PACKAGES = {
  ALL_ONE: 'ALL1',
  ALL_TWO: 'ALL2',
  ALL_MONTH: 'ALLMO',
  ALL_YEAR: 'ALLYR',
  NHL_FULL: 'NHLFULL',
  NFL_FULL: 'NFLFULL',
  NCAAF_FULL: 'NCAAFFULL',
  NBA_FULL: 'NBAFULL',
  NCAAB_FULL: 'NCAABFULL',
  MLB_FULL: 'MLBFULL'
}



// WEBPACK FOOTER //
// ./src/constants.js